import { handleSupabaseSingle, supabase } from '../../lib/supabase-unified';
import { Course } from '../../types';

const COURSE_LIST_SELECT =
  'id, title, slug, created_at, status, mobile_banner_url, desktop_banner_url, wp_id, type, redirect_url, thumbnail, discussion_url, avatar_url_mobile, avatar_url_desktop, summary, skill_level, instruments, metadata';

export const getCourseBySlug = async (slug: string): Promise<Course> => {
  return handleSupabaseSingle<Course>(
    supabase
      .from('courses')
      .select(COURSE_LIST_SELECT)
      .eq('slug', slug)
      .maybeSingle() as any
  );
};
